module.exports = __webpack_public_path__ + "img/icon-calendar.9a8284b7.svg";